/**
 * 项目首页
 */
import React, { useEffect, useState } from 'react';
import styles from './tumorChannel.module.scss';
import tumorChannel0 from '../../static/images_doctor/tumorChannel0.png';
import tumorChannel1 from '../../static/images_doctor/tumorChannel1.png';
import tumorChannel2 from '../../static/images_doctor/tumorChannel2.png';
import tumorChannel3 from '../../static/images_doctor/tumorChannel3.png';
import tumorChannel4 from '../../static/images_doctor/tumorChannel4.png';
import tumorChannel5 from '../../static/images_doctor/tumorChannel5.png';
import tumorChannel6 from '../../static/images_doctor/tumorChannel6.png';
import tumorChannel7 from '../../static/images_doctor/tumorChannel7.png';

function TumorChannel(props: any) {

    useEffect(() => {
        //设置网页title
        document.title = '工具介绍';
    }, [])

    return (
        <div className={styles.tumorChannelContent}>
            <img src={tumorChannel0} alt='' width={'100%'} style={{ minHeight: '322px' }} />
            <img src={tumorChannel1} alt='' width={'100%'} style={{ minHeight: '547.5px' }}  />
            <img src={tumorChannel2} alt='' width={'100%'} style={{ minHeight: '473px' }} />
            <img src={tumorChannel3} alt='' width={'100%'} style={{ minHeight: '413.5px' }} />
            <img src={tumorChannel4} alt='' width={'100%'} style={{ minHeight: '476px' }} />
            <img src={tumorChannel5} alt='' width={'100%'} style={{ minHeight: '534px' }} />
            <img src={tumorChannel6} alt='' width={'100%'} style={{ minHeight: '537.5px' }} />
            <img src={tumorChannel7} alt='' width={'100%'} style={{ minHeight: '579.5px' }} />
        </div>
    )
}

export default TumorChannel;